<template>
  <div class="create-customer">
    <div class="modal-button">
      <button class="btn btn-ss-standout"
              type="button"
              @click="$modal.show(`create-customer-modal`)">
        + Customer
      </button>
    </div>
    <vjs-modal name="create-customer-modal"
               title="Create New Customer"
               icon="la la-plus-circle"
               :adaptive="false">
      <template slot="body-content">
        <form class="kt-form kt-form--fit kt-form--label-align-right kt-form--group-seperator-dashed">
          <div class="form-group kt-form__group row">
            <div class="col-12">
              <div class="input-group kt-input-group kt-input-group--square">
                <label>Organisation</label>
                <multiselect v-model="selected_organisation" :options="organisations"
                             label="name"
                             track-by="uuid" :allow-empty="false"
                             placeholder="Select an Organisation" />
              </div>
            </div>

            <div class="col-12">
              <hr>
            </div>

            <div class="col-12 col-md-6">
              <label>Name</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-user" /></span>
                </div>
                <input v-model="name"
                       v-validate="'required|alpha_num_spaces'"
                       type="text" name="name"
                       :class="{'form-control': true, 'has-error': errors.has('name') }"
                       class="kt-input" placeholder=""
                       autocomplete="off">
              </div>
              <transition name="fade">
                <p v-show="errors.has('name')" class="help is-danger">
                  {{ errors.first('name') }}
                </p>
              </transition>
              <span class="kt-form__help" />
            </div>

            <div class="col-12 col-md-6">
              <label>Plan</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-map-o" /></span>
                </div>
                <select v-model="plan" class="form-control kt-input" name="plan">
                  <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                    {{ plan.label }}
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-6">
              <label>Status</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-lightbulb-o" /></span>
                </div>
                <select v-model="status" class="dropdown-square form-control kt-input" name="status">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-6 mt-2">
              <label>Api Access</label>
              <input v-if="!selected_plan_has_api_access" type="text"
                     class="form-control"
                     value="not in plan" disabled>
              <div v-else class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-lightbulb-o" /></span>
                </div>
                <select v-model="api_access" class="dropdown-square form-control kt-input" name="api_access">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-6 mt-2">
              <label>Ads Enabled</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-lightbulb-o" /></span>
                </div>
                <select v-model="ads_enabled" class="dropdown-square form-control kt-input" name="ads_enabled">
                  <option value="1">
                    Enabled
                  </option>
                  <option value="0">
                    Disabled
                  </option>
                </select>
              </div>
              <span class="kt-form__help" />
            </div>
            <div class="col-12 col-md-6 mt-2">
              <label>Storage Allocation</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text icon-color">GB</span>
                </div>
                <input v-validate="'required|numeric'"
                       :value="storage_allocation"
                       type="text" class="form-control kt-input"
                       name="storage_allocation" :class="{'form-control': true, 'has-error': errors.has('storage_allocation')}"
                       placeholder="">
              </div>
              <span class="kt-form__help" />
              <transition name="fade">
                <p v-show="errors.has('storage_allocation')" class="help is-danger">
                  {{ errors.first('storage_allocation') }}
                </p>
              </transition>
            </div>
            <div class="col-12 col-md-6 mt-2">
              <label>Live Feed Limit</label>
              <div class="input-group kt-input-group kt-input-group--square">
                <div class="input-group-prepend">
                  <span class="input-group-text"><i class="la la-rss" /></span>
                </div>
                <input v-model="live_feed_limit"
                       v-validate="'required|numeric'"
                       type="text" class="form-control kt-input"
                       name="live_feed_limit" :class="{'form-control': true, 'has-error': errors.has('live_feed_limit')}"
                       placeholder="">
              </div>
              <transition name="fade">
                <p v-show="errors.has('live_feed_limit')" class="help is-danger">
                  {{ errors.first('live_feed_limit') }}
                </p>
              </transition>
            </div>
          </div>
        </form>

        <div class="row">
          <div class="col-12 mt-4">
            <div class="alert alert-secondary" role="alert">
              <div class="alert-icon">
                <i class="flaticon-questions-circular-button" />
              </div>
              <div class="alert-text">
                <strong>Recommended Live Feed Limits</strong><br>
                Basic = 0<br>
                Pro = 2<br>
                Enterprise = 50
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="body-controls">
        <button type="button" class="btn btn-ss-standout" @click="saveCustomer">
          Save Customer
        </button>
        <button type="button" class="btn btn-ss"
                @click="closeModal">
          Close
        </button>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import VjsModal from "VueModals/VjsModal";
import { handleAxiosError } from "AssetsJs/helpers/responses";

export default {
  components: {
    VjsModal,
  },
  props: {
    organisations: {
      type: Array,
      required: false,
      default: () => (window.organisations),
    },
    plans: {
      type: Array,
      required: false,
      default: () => (window.plans),
    },
  },
  data: () => ({
    name: null,
    status: 1,
    plan: 1,
    storage_allocation: 100,
    api_access: 1,
    selected_organisation: null,
    ads_enabled: 0,
    live_feed_limit: 0,
    sales_accounts: [],
    selected_sales_account: null,
  }),
  computed: {
    selected_plan() {
      if (!this.plan) {
        return null;
      }
      return _.find(this.plans, plan => plan.id === this.plan);
    },
    selected_plan_has_api_access() {
      if (!this.selected_plan) {
        return false;
      }

      return _.find(this.selected_plan.features, feature => feature.slug === 'api');
    },
  },
  mounted() {
    this.selected_organisation = this.organisations[0];
  },
  methods: {
    prePopulateCompanyName(selection) {
      this.name = selection.name;
    },
    closeModal() {
      this.$modal.hide(`create-customer-modal`);
    },
    async saveCustomer() {
      try {
        const valid = await this.$validator.validateAll();
        if (valid) {
          const payload = {
            name: this.name,
            plan_id: this.plan,
            status: this.status,
            api_access: this.api_access,
            storage_allocation: this.storage_allocation,
            organisation_uuid: this.selected_organisation.uuid,
            ads_enabled: this.ads_enabled,
            live_feed_limit: this.live_feed_limit,
          };

          const response = await axios.post("/api/v1/admin/customer", payload);

          if (response) {
            toastr.success('Customer Created');
            this.closeModal();
            EventBus.$emit("customerAdded", response.data.data);
          }
        }
      } catch (error) {
        if (error.response.status === 422) {
          const errors = error.response.data.errors;
          for (const k in errors) {
            if (Object.prototype.hasOwnProperty.call(k)) {
              toastr.error(errors[k]);
            }
          }
        } else {
          handleAxiosError(error);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  label {
    font-weight: bold;
  }
</style>
